import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'lex-edit-input',
    templateUrl: './edit-input.component.html',
    styleUrls: ['./edit-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditInputComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class EditInputComponent implements OnInit {
 
  @Input() value: string = '';
  @Input() placeholder: string = '';
	@Input() type: 'input' | 'textarea' = 'input';
  @Input() rows: number = 3;
  @Output() setValue = new EventEmitter<string>();
  @Output() cancelValue = new EventEmitter();

  public placeholderText: string;

  public ngOnInit(): void {
    this.placeholderText = `Enter ${this.placeholder} and press Enter.`
  }

  public setEdit(): void {
    this.setValue.emit(this.value);
  }

  public onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      this.setEdit();
      event.preventDefault();
    }
  }
}
